<div>
    <div class="services-step-title">
        {{'EDIT_SERVICES.FUEL_CHARGE.0' | translate}}
    </div>
    <div class="services-step-description">
        {{'EDIT_SERVICES.FUEL_CHARGE.1' | translate}}
    </div>
    <div class="services-step-subtitle">
        {{'EDIT_SERVICES.FUEL_CHARGE.2' | translate}}
    </div>
    <div class="services-step-subtitle-description">
        <span>+{{refillTopping?.price}}{{ ServiceForm?.value?.AddressData.OriginAddress
            .ZoneId | CurrencyByZoneId
            }}</span> {{'EDIT_SERVICES.FUEL_CHARGE.6' | translate}}
    </div>

    <div class="d-flex monetary-amount-options">
        <div *ngFor="let amount of MonetaryAmounts; let i = index"
            [ngClass]="{ checked: SelectedMonetaryAmount === i + 1 }" (click)="selectMonetaryAmount(i + 1)"
            (keydown)="selectMonetaryAmount(i + 1)" tabindex="0">
            <span class="price">{{ MonetaryAmounts[i] }}{{ ServiceForm?.value[FORM_KEYS.AddressData][FORM_KEYS.ZoneId] |
                CurrencyByZoneId }}</span>
            <span class="subtitle">{{'EDIT_SERVICES.FUEL_CHARGE.4' | translate}}</span>
        </div>
    </div>



    <div class="info-notification" style="margin-top: 14px;">
        <img src="assets/icons/information-circle-2.svg" alt="Info icon" />
        <div>
            <p class="text-info-notification">
                {{'EDIT_SERVICES.FUEL_CHARGE.5' | translate}}
            </p>
        </div>
    </div>
</div>